import axiosInstance from '@/apis/axiosInstance';

export type InfluencerAccount = {
  influencerId?: string | number;
  platform?: string;
  platformId?: string | number;
  channelKey?: string;
  username?: string;
  name?: string;
  profileLink?: string;
  profilePictureLink?: string;
  followerCount?: number;
  status?: string;
  [key: string]: unknown;
};

export const getInfluencerAccounts = async (options?: {
  strict?: boolean;
}): Promise<InfluencerAccount[]> => {
  const { data } = await axiosInstance.get('/influencer/accounts');
  if (data?.code === 0 && Array.isArray(data.data)) return data.data;
  if (options?.strict) throw new Error('Unable to verify connected accounts.');
  return [];
};
